import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45a41298")

_pushScopeId("data-v-45a41298")
const _hoisted_1 = { class: "device-add modal grid center middle" }
const _hoisted_2 = { class: "device-add-form card grid" }
const _hoisted_3 = { class: "title row center" }
const _hoisted_4 = {
  key: 0,
  class: "error row"
}
const _hoisted_5 = { class: "form-group col-1" }
const _hoisted_6 = { class: "form-group col-1" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  class: "btn",
  type: "submit"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("hr", { class: "row" }, null, -1)
const _hoisted_10 = { class: "row center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h1", null, _toDisplayString(_ctx.$t("add-device-title")), 1)
      ]),
      (_ctx.errorText)
        ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.errorText)), 1))
        : _createCommentVNode("", true),
      _createVNode("form", {
        class: "row",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.save()), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_5, [
          _withDirectives(_createVNode("input", {
            id: "device.name",
            required: "",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.device.name = $event)),
            placeholder: _ctx.$t('device.name')
          }, null, 8, ["placeholder"]), [
            [_vModelText, _ctx.device.name]
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _withDirectives(_createVNode("input", {
            id: "device.code",
            required: "",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.device.code = $event)),
            placeholder: _ctx.$t('device.code')
          }, null, 8, ["placeholder"]), [
            [_vModelText, _ctx.device.code]
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("button", _hoisted_8, _toDisplayString(_ctx.$t("add")), 1)
        ])
      ], 32),
      _hoisted_9,
      _createVNode("div", _hoisted_10, [
        _createVNode("a", {
          href: "#",
          class: "small",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
        }, _toDisplayString(_ctx.$t("cancel")), 1)
      ])
    ])
  ]))
})